import {entityList, entitySave, entityUpdate, executeCall} from './CallService';

export const codelist = async () => {
    return await entityList('code')
};

export const codeCreate = async(dbValues) => {
    return entitySave("code", dbValues);
}

export const codeUpdate = async(dbValues) => {
    return entityUpdate("code", dbValues);
}

export const codeOrderUpdate = async (codes) => {
    const action = "query.dml";
    const data = {
        query: "updateCodesOrder",
        values: codes
    };
    return await executeCall(action, data);
};
